//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Onboarding.Welcome',
                {
                    url: '/Welcome',
                    component: 'welcomeComponent',
                });
        }
    ]);

    app.component('welcomeComponent', {
        templateUrl: 'App.Onboarding/States/Welcome/Welcome.template.html',
        controller: 'WelcomeController',
        bindings: {
            logo: '<',
            onBehalfOfUserGroup: '<',
            onBehalfOfUser: '<',
            user: '<',
            userGroup: '<',
        }
    });

    app.controller('WelcomeController', WelcomeController);

    WelcomeController.$inject = ['AuthService', 'permissionService', '$state'];

    function WelcomeController(AuthService, permissionService, $state) {
        var $ctrl = this;
        $ctrl.goToNext = function () {
            // if ([needs maa]) {
            $state.go('Onboarding.Agreement');
            // } else $state.go('Onboarding.CarrierSetup');
        };
    }
})(window.angular, window.app);